import { SerializedStyles } from '@emotion/react'
import React from 'react'

import Text from 'components/common/Text'
import theme from 'theme'

interface TitleWithIconProps {
  icon?: (props: any) => any
  label?: string
  iconStyle?: Record<string, SerializedStyles>
  textStyle?: Record<string, SerializedStyles>
  // TODO TS - this is a difficult type conversion due to implementing the Text component as a ForwardRef. Using the "any" type to avoid tslint issues for the time being.
  as?: keyof JSX.IntrinsicElements | React.ComponentType | any
  className?: string
}

const TitleWithIcon: React.FC<TitleWithIconProps> = ({
  icon: IconComponent,
  label,
  textStyle,
  iconStyle,
  as = 'h4',
  className,
  ...rest
}) => {
  return (
    <div
      className={className}
      css={{
        alignItems: 'center',
        display: 'grid',
        gap: theme.space[2],
        gridTemplateColumns: 'min-content auto'
      }}
    >
      <IconComponent
        css={{
          fontSize: theme.fontSizes[2],
          color: theme.colors.steel[1],
          ...iconStyle
        }}
      />
      <Text overflowEllipsis as={as} color="medium" css={textStyle} {...rest}>
        {label}
      </Text>
    </div>
  )
}

TitleWithIcon.displayName = 'TitleWithIcon'

export default TitleWithIcon
